import React, { useContext } from 'react';
import { OverlayTrigger, OverlayTriggerProps } from 'react-bootstrap';
import { ServicesContext } from '~/services';

export function BSOverlay(props: OverlayTriggerProps) {
    const { mainRef } = useContext(ServicesContext);
    return <OverlayTrigger container={mainRef} {...props} />;
}
